import { AppConfigUrlsType } from './types/config';
import { getEnv } from './utils/env';

let cfg: AppConfigUrlsType;

type ServiceURLs = Omit<AppConfigUrlsType, 'URL_CDN_MEDIA'>;

const getServices = (url: string): ServiceURLs => {
  const services: (keyof ServiceURLs)[] = [
    'URL_SERVICE_DEFAULT',
    'URL_SERVICE_APPLICATION',
    'URL_SERVICE_AUTH',
    'URL_SERVICE_BILLING',
    'URL_SERVICE_BUYINGUNIT',
    'URL_SERVICE_CLASSIFICATION',
    'URL_SERVICE_CONTRIBUTION',
    'URL_SERVICE_CORE',
    'URL_SERVICE_EDA',
    'URL_SERVICE_ETL',
    'URL_SERVICE_EXCHANGE',
    'URL_SERVICE_FIELD',
    'URL_SERVICE_GDSN',
    'URL_SERVICE_IMPORT_PRODUCT',
    'URL_SERVICE_INDEXER',
    'URL_SERVICE_KPI',
    'URL_SERVICE_KRONOS',
    'URL_SERVICE_MEDIA',
    'URL_SERVICE_MESSAGE',
    'URL_SERVICE_NOTIFICATION',
    'URL_SERVICE_ONBOARDING',
    'URL_SERVICE_PRODUCT',
    'URL_SERVICE_REVIEW',
    'URL_SERVICE_PUBLIC',
    'URL_SERVICE_RFP',
    'URL_SERVICE_SALESFORCE',
    'URL_SERVICE_SEARCH',
    'URL_SERVICE_TRANSACTION',
    'URL_SERVICE_TRANSLATION',
    'URL_SERVICE_VALIDATION',
  ];
  return services.reduce<ServiceURLs>((acc, service) => {
    acc[service] = url;
    return acc;
  }, {} as any);
};

export const getConfig = () => {
  if (cfg) {
    return cfg;
  }
  const { env, pillarName, appconfig, parentHostname } = getEnv();

  if (appconfig.urls) {
    cfg = appconfig.urls;
  } else if (env === 'ppr') {
    const serviceUrl = `https://ppr-apis.${parentHostname}`;
    cfg = {
      ...getServices(serviceUrl),
      URL_CDN_MEDIA: `https://ppr-smedia.${parentHostname}`,
    };
  } else if (env === 'ltg') {
    const serviceUrl = `https://ltg-apis.${parentHostname}`;
    cfg = {
      ...getServices(serviceUrl),
      URL_CDN_MEDIA: `https://ltg-smedia.${parentHostname}`,
    };
  } else if (['int', 'alk'].includes(env)) {
    const host = pillarName
      ? `${pillarName}.int.${parentHostname}`
      : window.location.hostname.replace(/^admin-/g, '');
    return {
      ...getServices(`https://${host}`),
      URL_CDN_MEDIA: `https://intafcmedia.blob.core.windows.net/media`,
    };
  } else {
    const serviceUrl = `https://apis.${parentHostname}`;
    cfg = {
      ...getServices(serviceUrl),
      URL_CDN_MEDIA: `https://smedia.${parentHostname}`,
    };
  }
  return cfg;
};

export default getConfig;

export const getServiceUrl = (
  serviceName:
    | 'default'
    | 'application'
    | 'auth'
    | 'billing'
    | 'buyingunit'
    | 'classification'
    | 'contribution'
    | 'core'
    | 'eda'
    | 'etl'
    | 'exchange'
    | 'field'
    | 'gdsn'
    | 'import_product'
    | 'indexer'
    | 'kpi'
    | 'kronos'
    | 'media'
    | 'merchandising'
    | 'message'
    | 'notification'
    | 'onboarding'
    | 'product'
    | 'review'
    | 'public'
    | 'rfp'
    | 'salesforce'
    | 'search'
    | 'transaction'
    | 'translation'
    | 'validation',
) => {
  const cfg = getConfig();
  return (
    cfg[
      `URL_SERVICE_${serviceName.toUpperCase()}` as keyof AppConfigUrlsType
    ] || cfg.URL_SERVICE_DEFAULT
  );
};
